import { AppName } from '@bowtie-web/common';
import { DemographicInput } from '../types';

export const BASENAME = import.meta.env.REACT_APP_BASENAME || '';
export const APP_NAME_BASE = AppName.Quotation;

export const HKD = 'hkd';
export const MALE = 'male';
export const FEMALE = 'female';
export const SMOKER = 'smoker';
export const NON_SMOKER = 'non-smoker';
export const DEFAULT_PRODUCT_TYPE = 'vhis';
export const VALID_PRODUCT_TYPES = ['accidental-medical', 'vhis'];
export const PRODUCT_TYPE_MAPPING = {
  'accidental-medical': '意外醫療保險',
  vhis: '自願醫保',
};
export const DESCRIPTION_MAPPING = {
  'accidental-medical':
    '毋須留下個人資料，亦可預先估計「保泰意外保險-觸木保」的每月保費，立即免費報價！',
  vhis: '毋須留下個人資料，亦可預先估計Bowtie自願醫保「標準計劃」及「靈活計劃」保費，立即免費報價！',
};
export const SUM_ASSURED_STEP = 100000;
export const SUM_ASSURED_DEFAULT = 1000000;
export const INITIAL_RANGE = {
  min: 200000,
  max: 8000000,
};

export const COMPARISON_PAGE_URLS_LANG_MAPPING = {
  'zh-hk': 'https://www.bowtie.com.hk/zh/insurance/vhis/comparison',
  en: 'https://www.bowtie.com.hk/en/insurance/vhis/comparison',
};

export const APP_START_URL_LOCAL_STORAGE_KEY = 'quotationAppStartUrl';

export const DEMOGRAPHIC_INPUTS_DEFAULT_ORDER = [
  DemographicInput.Gender,
  DemographicInput.Age,
  DemographicInput.Smoker,
];

export const ALLOWED_PARENT_ORIGIN =
  import.meta.env.REACT_APP_MARKETING_SITE_ORIGIN || window.location.origin;
